<template>
    <section v-if="uniqueChanges.length > 0">
        <h2>Incremental Budget Changes</h2>
        <table v-cloak class="table table-striped">
            <thead>
                <th></th>
                <th>{{ year }} Budget</th>
                <th>{{ year }} FTE</th>
            </thead>
            <Row v-for="(change, index) in uniqueChanges" 
                :key="department + '-' + index + '-' + change.name" 
                :name="change.name" 
                :children="filteredChanges(change)"
                :years="years"
            />
        </table>
    </section>
</template>

<script>
    import Row from '@/components/Row';

    export default {
        name: 'Changes',
        props: {
            'years' : Array,
            'changes' : Array,
            'year' : String,
            'department' : String
        },
        components: {
            Row
        },
        computed: {
            uniqueChanges() {  /* Returns array of just BCL names */
                const uniques = [],
                    map = new Map();
                    
                for (const item of this.changes) {
                    if(!map.has(item.report_section)){
                        map.set(item.report_section, true);
                        uniques.push({
                            name: item.report_section
                        });
                    }
                }
                return uniques;
            }
        },
        methods: {
            filteredChanges(change) {
                return this.changes.filter(child => {
                    return child.report_section == change.name;
                })
            },
            yearName(prop) {
                let name = prop.split('_').join(' ');
                return name;
            }
        }
    }
</script>


<style scoped>
    th {
        text-transform: capitalize;
    }
</style>
